/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProcessResult_GenericApiResponse } from '../models/ProcessResult_GenericApiResponse';
import type { Wealthlane_Dtos_BulkRolePublishedToCompanyDto } from '../models/Wealthlane_Dtos_BulkRolePublishedToCompanyDto';
import type { Wealthlane_Dtos_RolePublishedToCompanyDto } from '../models/Wealthlane_Dtos_RolePublishedToCompanyDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RolePublishedToCompanyService {

    /**
     * @param requestBody 
     * @returns ProcessResult_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppRolePublishedToCompanyManage(
requestBody?: Wealthlane_Dtos_BulkRolePublishedToCompanyDto,
): CancelablePromise<ProcessResult_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/role-published-to-company/manage',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static patchApiIdentityApiAppRolePublishedToCompany(
id: string,
requestBody?: Wealthlane_Dtos_RolePublishedToCompanyDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/identity/api/app/role-published-to-company/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static deleteApiIdentityApiAppRolePublishedToCompany(
id: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/identity/api/app/role-published-to-company/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppRolePublishedToCompany(
formData?: {
DestinationCompanyId?: string;
SourceRoleId?: string;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/role-published-to-company',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
